import {
  Auth,
  browserLocalPersistence,
  browserPopupRedirectResolver,
  connectAuthEmulator,
  getAuth,
  indexedDBLocalPersistence,
  initializeAuth
} from 'firebase/auth';
import { app } from './firebaseApp';

// Persistence must be fixed at initialization. getAuth() defaults to
// IndexedDB first, so every page load migrated the session out of
// localStorage (deleting that key) before a later persistence change moved it
// back. Other open tabs observed the deletion as a sign-out and bounced to
// the login page. Keeping localStorage first means no migration or deletion.
const createAuth = (): Auth => {
  try {
    return initializeAuth(app, {
      persistence: [browserLocalPersistence, indexedDBLocalPersistence],
      popupRedirectResolver: browserPopupRedirectResolver
    });
  } catch {
    // Already initialized (for example, after a hot reload).
    return getAuth(app);
  }
};

export { app };
export const auth = createAuth();

const isLocalHost = typeof window !== 'undefined'
  && ['localhost', '127.0.0.1'].includes(window.location.hostname);

if (isLocalHost) {
  const host = window.location.hostname;
  connectAuthEmulator(auth, `http://${host}:9099`, { disableWarnings: true });
}
